import React from "react";
import { Link } from "react-router-dom";
import { Bell, MapPin, Coins, Layers, CheckCircle2, ArrowRight, TrendingUp } from "lucide-react";
import { CAMPAIGNS, RECENT_ACTIVITY, SPOT_STATUSES } from "../../data/mockData";
import SampleDataBanner from "../../components/SampleDataBanner";

function StatCard({ label, value, icon: Icon, tone = "gold" }) {
  return (
    <div className="sb-card p-4">
      <div className="flex items-center justify-between">
        <div className="sb-eyebrow" style={{ fontSize: 10 }}>{label}</div>
        <Icon size={16} className={tone === "gold" ? "text-[#FFC107]" : "text-[#A1A1AA]"} />
      </div>
      <div className="mt-2 text-[22px] font-black">{value}</div>
    </div>
  );
}

export default function ScoutHome() {
  const featured = CAMPAIGNS[0];
  return (
    <div className="p-4 pb-6">
      <SampleDataBanner compact className="mb-4" />
      {/* Top row */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <MapPin size={16} className="text-[#FFC107]" />
          <span className="font-black tracking-tight text-[14px]">SPOTBOUNTY</span>
        </div>
        <div className="flex items-center gap-3">
          <button className="relative w-8 h-8 rounded-full bg-[#15191D] border border-[#2A2F34] flex items-center justify-center">
            <Bell size={14} />
            <span className="absolute top-1 right-1 w-1.5 h-1.5 rounded-full bg-[#FFC107]" />
          </button>
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#FFC107] to-[#E6AC00] flex items-center justify-center text-[#080B0D] font-black text-[12px]">
            AJ
          </div>
        </div>
      </div>

      <div className="mt-6">
        <div className="text-[12px] text-[#A1A1AA]">Good morning, Alex</div>
        <h1 className="sb-headline mt-2 text-[30px]">
          FIND A SPOT.
          <br />
          EARN THE <span className="text-[#FFC107]">BOUNTY.</span>
        </h1>
      </div>

      <Link to="/app/scout/submit" data-testid="scout-submit-cta" className="mt-6 sb-btn-primary w-full text-[13px]">
        Submit a Spot <ArrowRight size={16} />
      </Link>

      {/* 2x2 stats */}
      <div className="mt-6 grid grid-cols-2 gap-3">
        <StatCard label="Pending Earnings" value="$250" icon={Coins} />
        <StatCard label="Paid Earnings" value="$675" icon={Coins} />
        <StatCard label="Active Spots" value="8" icon={Layers} />
        <StatCard label="Sold Spots" value="3" icon={CheckCircle2} />
      </div>

      {/* High demand card */}
      <div className="mt-6">
        <div className="sb-eyebrow flex items-center gap-2">
          <TrendingUp size={12} className="text-[#FFC107]" />
          High Demand Near You
        </div>
        <Link
          to="/app/scout/campaigns"
          data-testid="high-demand-card"
          className="mt-3 sb-card block overflow-hidden hover:border-[#FFC107]/50 transition-colors"
        >
          <div className="relative sb-image-dim h-28">
            <img src={featured.image} alt="" className="w-full h-full object-cover" />
            <div className="absolute top-3 left-3 sb-pill sb-pill-gold">High Operator Demand</div>
          </div>
          <div className="p-4">
            <div className="font-black text-[15px]">{featured.title}</div>
            <div className="mt-1 text-[12px] text-[#A1A1AA]">{featured.verticals} · {featured.employees}</div>
            <div className="mt-3 flex items-center justify-between">
              <span className="text-[12px] text-[#FFC107] font-bold">{featured.bounty}</span>
              <span className="text-[11px] text-[#A1A1AA] flex items-center gap-1">View campaign <ArrowRight size={12} /></span>
            </div>
          </div>
        </Link>
      </div>

      {/* Recent activity */}
      <div className="mt-6">
        <div className="sb-eyebrow">Recent Activity</div>
        <div className="mt-3 sb-card divide-y divide-[#2A2F34]">
          {RECENT_ACTIVITY.map((a) => {
            const st = SPOT_STATUSES.find((s) => s.key === a.status);
            return (
              <div key={a.id} className="p-4 flex items-center justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <div className="text-[13px] truncate">{a.text}</div>
                  <div className="text-[11px] text-[#52525b] mt-0.5">{a.time}</div>
                </div>
                <span className={`sb-pill ${st?.pill || "sb-pill-gray"}`} style={{ fontSize: 9 }}>{st?.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
